module.exports = __webpack_public_path__ + "img/west-ham-united.e2cc7108.png";